import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
// import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
// import { SubItemComponent } from '../sub-item/sub-item.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sub-item-list',
  templateUrl: './sub-item-list.component.html',
  styleUrls: ['./sub-item-list.component.css']
})
export class SubItemListComponent implements OnInit {

  public menu_item_id = '2';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  displayedColumns = ['chx_select', 'sub_item_number', 'main_item_name', 'main_item_name_en', 'sub_item_no', 
    'unit_name','item_subcat_name', 'item_cat_name', 'print_barcode', 'edit', 'del'];
  displayedColumns2 = ['sub_item_number', 'main_item_name', 'main_item_name_en', 'sub_item_no', 'unit_name',
    'item_subcat_name', 'item_cat_name'];
  dataSource = new MatTableDataSource(this.dp);
  // addDialogRef: MatDialogRef<SubItemComponent>; , public dialog: MatDialog
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'sub_item', 'main_item_name': '', 'sub_item_no': '', 'title': 'قائمة الأصناف',
    'item_cat_id': '', 'item_subcat_id': ''
  };

  Main_Item_Name; Sub_Item_Number; Success_Msg; Error_Msg; Del_Msg;
  No_Item_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService, private router: Router) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Main_Item_Name').subscribe((res: string) => {
      this.Main_Item_Name = res;
    });

    translate.get('Sub_Item_Number').subscribe((res: string) => {
      this.Sub_Item_Number = res;
    }); 

    translate.get('No_Item_Msg').subscribe((res: string) => {
      this.No_Item_Msg = res;
    });
  }

  ngOnInit() {

    let href = this.router.url;
    let urlParts = href.split("/");

    if (urlParts[2] == '5')
      this.menu_item_id = '2';
    else if (urlParts[2] == '12')
      this.menu_item_id = '108';


    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query, obj;
    query = this.queryList.all_itemCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.itemCats = data.data['list'];
      });

    query = this.queryList.all_itemSubCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_itemSubCats = data.data['list'];
      });

  }

  getSubCat() {
    this.itemSubCats = [];
    this.all_itemSubCats.forEach(element => {
      if (element.item_cat_id == this.model['item_cat_id'])
        this.itemSubCats.push(element);
    });
    if (this.itemSubCats.length > 0)
      this.model['item_subcat_id'] = this.itemSubCats[0]['item_subcat_id'];
  }

  search() {
    let condition = "";

    if (this.model['main_item_name'] != '')
      condition += " AND (`main_item`.`main_item_name` LIKE '%" + this.model['main_item_name'] +
        "%' OR `main_item`.`main_item_name_en` LIKE '%" + this.model['main_item_name'] + "%')";

    if (this.model['sub_item_no'] != '')
      condition += " AND `sub_item`.`sub_item_no` LIKE '%" + this.model['sub_item_no'] + "%'";

    if (this.model['item_cat_id'] != '')
      condition += " AND `item_cat`.`item_cat_id` = '" + this.model['item_cat_id'] + "'";

    if (this.model['item_subcat_id'] != '')
      condition += " AND `main_item`.`item_subcat_id` = '" + this.model['item_subcat_id'] + "'";

    let query = "SELECT `sub_item`.*, `main_item`.`main_item_id`, `main_item`.`main_item_name`, `main_item`.`main_item_name_en`, " +
      "`unit`.`unit_name`, `item_subcat`.`item_subcat_name`, `item_cat`.`item_cat_name` FROM `sub_item`, " +
      "`main_item`, `unit`, `item_subcat`, `item_cat` WHERE `sub_item`.`status` = '1' AND " +
      "`sub_item`.`main_item_id` = `main_item`.`main_item_id`" + condition +
      " AND `sub_item`.`unit_id` = `unit`.`unit_id` AND `main_item`.`item_subcat_id` = `item_subcat`.`item_subcat_id` AND " +
      "`item_subcat`.`item_cat_id` = `item_cat`.`item_cat_id`";

    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  // openDialog(main_item_id = null) {
  //   this.addDialogRef = this.dialog.open(SubItemComponent, {
  //     hasBackdrop: false,
  //     data: (main_item_id != null ? main_item_id : null),
  //     width: "90%",
  //     height: "95%"
  //   });
  //   this.addDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       if (main_item_id != null)
  //         this.search();
  //     });
  // }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="50%"> ' + this.Main_Item_Name + ': ' + this.model['main_item_name'] + '</td>';
    html_data += '<td width="50%"> ' + this.Sub_Item_Number + ': ' + this.model['sub_item_no'] + '</td>';
    html_data += '</tr></table>';

    let table = (document.getElementById('subItem_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  // newSubItem() {
  //   this.addDialogRef = this.dialog.open(SubItemComponent, {
  //     hasBackdrop: false,
  //     width: "90%",
  //     height: "95%"
  //   });
  //   this.addDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //     });
  // }

  printBarcode(row = null) {
    if (row != null)
      window.open(this.applicationConstants.generateBarcode + "?sub_item_id=" + row.sub_item_id, "_blank");
    else {
      let count = 0;
      let sub_item_list = '';
      this.dp.forEach(element => {
        if ((document.getElementById('chx_select_' + element.sub_item_id) as HTMLInputElement).checked) {
          count++;
          if (sub_item_list != '')
            sub_item_list += ';';
          sub_item_list += element.sub_item_id; 
        }
      });

      if (count == 0) 
        alert(this.No_Item_Msg);
      else {
        let form = (document.getElementById('form1') as HTMLFormElement);
        let html_data_field = document.forms[form.id]['html_data'] as HTMLInputElement;
        html_data_field.value = String(sub_item_list);
        form.action = this.applicationConstants.generateBarcode + "?sub_list"; 
        form.submit();
      }
    }
  }

  // editSubItem(row) {
  //   this.addDialogRef = this.dialog.open(SubItemComponent, {
  //     hasBackdrop: false,
  //     data: row.main_item_id,
  //     width: "90%",
  //     height: "95%"
  //   });
  //   this.addDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       this.search();
  //     });
  // }

  delete(sub_item_id) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'sub_item_id': sub_item_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
